module.exports = __webpack_public_path__ + "static/sarkani-cc370e7dc3f842fd551291ebabcb66c1.jpg";